import { useContext } from "react";
import { OffcanvasContext } from "../contexts/OffcanvasContext";

const useOffcanvas = () => useContext(OffcanvasContext);

export default useOffcanvas;
